import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { AllocateServiceWizardStoreEffectsV26 } from './effects';
import * as fromAllocateServiceWizardStoreV26 from './reducer';

export function provideAllocateServiceWizardStoreV26(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(fromAllocateServiceWizardStoreV26.allocateServiceWizardStoreFeatureKey, fromAllocateServiceWizardStoreV26.reducer),
    provideEffects(AllocateServiceWizardStoreEffectsV26),
  ]);
}
